import { Controller } from '@hotwired/stimulus'
import { scrollToPosition } from '../utilities'

export default class extends Controller {
  go(ev) {
    ev.preventDefault()

    this.firstFocusable ||= document.getElementById('header-logo')

    scrollToPosition({
      top: 0,
      left: 0,
    })

    this.firstFocusable.focus({
      preventScroll: true,
    })
  }
}
